import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import { Spinner } from "@phosphor-icons/react";

function Gate() {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F4F5F7] text-[#64748B]">
        <Spinner size={22} className="animate-spin" />
      </div>
    );
  }
  return user ? <Dashboard /> : <Login />;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#F4F5F7] text-[#0F172A]">
      <AuthProvider>
        <Gate />
      </AuthProvider>
      <Toaster theme="light" position="bottom-right" richColors />
    </div>
  );
}

export default App;
